import { render, staticRenderFns } from "./myFooter.vue?vue&type=template&id=28ebbbf0&scoped=true&"
import script from "./myFooter.vue?vue&type=script&lang=js&"
export * from "./myFooter.vue?vue&type=script&lang=js&"
import style0 from "./myFooter.vue?vue&type=style&index=0&id=28ebbbf0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ebbbf0",
  null
  
)

export default component.exports